import { TFunction } from 'react-i18next';
import { OptionType } from '@chargify/custom-ui-components';

import { PaymentProfileActions } from '../../hooks';
import { PaymentProfileType } from '../../models/paymentProfile';

const getPaymentMethodTranslation = (
  type: string,
  t: (key: string) => string
) => {
  return t(`payment_profile.${type}`);
};

export const getPaymentMethodOptions = (
  type: PaymentProfileType,
  t: TFunction<'subscriptions-manager'[]>,
  availableActions: PaymentProfileActions[]
): OptionType[] => {
  const typeTranslation = getPaymentMethodTranslation(type, t);
  const options: OptionType[] = [];

  if (
    availableActions.includes(
      PaymentProfileActions.USE_FOR_SUBSCRIPTION_BILLING
    )
  ) {
    options.push({
      label: t(`payment_profile.use_this_payment_method`),
      value: 'select_payment_method',
      divider: true,
    });
  }

  if (availableActions.includes(PaymentProfileActions.PREVIEW)) {
    options.push({
      label: t(`payment_profile.view_payment_method_details`, {
        paymentMethod: typeTranslation,
      }),
      value: 'view_details',
    });
  }

  if (availableActions.includes(PaymentProfileActions.DELETE)) {
    options.push({
      label: t(`payment_profile.delete_payment_method`, {
        paymentMethod: typeTranslation,
      }),
      value: 'delete_payment_method',
      color: 'danger.main',
    });
  }

  return options;
};
